export class MinLengthFieldError extends Error {
  constructor() {
    super("Length does not meet requirement.");
  }
}
